




















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TokenUser } from '@/TokenUser'
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import * as utils_topshot from '../utils_topshot';
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src
import { globalUC } from '../UserCache';

interface Link {
  name: string
  path: string
}

@Component({
  name: 'NavbarComponent',
  components: { 
    ModalWrapperComponent: () => import('@/components/ModalWrapperComponent.vue'),
    }
})
export default class NavbarComponent extends Vue {
  // prop reactive member variables publically available to the html template
  public links: Link[] = []
  public SHOW_USER: boolean = true

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public get siteName(): string { return 'LiveToken' }
  public get siteDomain(): string { return utils.getCurrentHostname() }
  public get navBarMessage(): string { return this.$store.state.navBarMessage }
  public get userIdentify(): string { return this.user.topShotVerified ? this.user._temp.account.username || this.user._temp.account.flowAddress : this.user.email}

  public showLoginStuff(): boolean { return true }

  public isTouchDevice(): boolean { return utils.isTouchDevice() }

  public async userChoseSignOut() { 
    await utils_auth.logout()
    utils_topshot.setDapperMode(false)
    this.$store.commit("setNavBarMessage", { navBarMessage: null });
  }
  public userChoseLogin() {
    utils_auth.setLocationAfterLogin({ name: "home" });
    (this.$refs.LoginFormModalComponent as ModalWrapperComponent).show('LiveToken Login', 'sm', null)
  }
  public userChoseRegister(): void {
    utils_auth.setLocationAfterLogin({ name: "home" });
    (this.$refs.RegisterFormModalComponent as ModalWrapperComponent).show('LiveToken Registration', 'sm', null)
  }
  public useChoseChangeEmail() {
    this.$nextTick(() => {
      (this.$refs.ChangeEmailFormComponent as ModalWrapperComponent).show('Change Email Address', 'md', { currentEmailAddress: this.user.email })
    })
  }  
  public async userChoseResendEmailVerification() {
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + `/api/auth/resendEmailConfirmationCode`;
      const response: any = await utils.makeGetCall(url);
      if (!response || !response.data) throw(new Error('NavbarComponent.resendEmail() got null response or null response.data'))

      // something is wrong with the alert
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }
      
      // might as well update the user
      if (response.data.user) {
        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)
        globalUC.add(user)      // might as well give cache the very latest one

        if (!response.data.verified) utils.toast(this, 'Email Sent', `Please click on the email confirmation sent to ${user.email}.`);
        else utils.toast(this, 'Already Verified', `Your email address, ${user.email}, is already verified.`);

      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not send email confirmation')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }
  }

  public useChoseChangePassword() {
    this.$nextTick(() => {
      (this.$refs.ResetPasswordFormComponent as ModalWrapperComponent).show('Reset Password', 'md', { usernameOrEmail: this.user.email })
    })
  }
  public useChoseLinkTopShotAccount(): void {
    (this.$refs.LinkAccountFormComponent as ModalWrapperComponent).show('Link Top Shot Account', 'md', null)
  }
  public useChoseEnableTelegramAlerts(): void {
    (this.$refs.EnableTelegramAlertsComponent as ModalWrapperComponent).show('Enable Telegram Alerts', 'md', null)
  }

  // private, non-reactive member variables
  private tab: string = null
  private cloudinaryWidget: any = null

  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    this.doTabs()
    this.tab = this.$route.path.split('/')[1]

    // utils.setCurrentTab(this.tab)
    if (this.$store.state.devmode) console.log(`navbar.pathChanged() ${this.$route.path} => this.tab: ${this.tab}`)
  }

  private async mounted(): Promise<void> {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    this.doTabs();

    // the user cache may have a later version of our user than our store (e.g. profile pic), so update it
    if (this.userId) {
      const userFromCache: TokenUser = await globalUC.get(this.userId, true)
      if (userFromCache) utils_auth.saveAuthStuffToStoreAndLocalStorage(userFromCache, null)
    }

    // dapper mode
    if (utils_topshot.getDapperMode()) this.$store.commit("setNavBarMessage", { navBarMessage: 'Dapper Admin' });

    // did here instead of Home.vue cuz we want *everyone* to see it not just folks who go to home
    // utils.showTopAlert('warning', '<b>Announcement:</b> The LiveToken FMV algorithm is updating soon. To get a live preview of the new algorithm, join the <a href="https://discord.gg/JMVFpJDNRV">LiveToken Discord server</a>.', null)
    // utils.showTopAlert('warning', 'LiveToken\'s FMV algorithm is updating soon. Join our <a href="https://discord.gg/JMVFpJDNRV">Discord</a> for a preview.', null)
    const now: Date = new Date()
    if (now < new Date('October 3, 2021 18:00:00')) utils.showTopAlert('success', '<b>🎂 Top Shot 100-Pack Giveaway 🎁</b> — See the <a href="https://twitter.com/LiveTokenCo/status/1443930322861576193">tweet</a> for instructions.', null)
    if (false) utils.showTopAlert('success', '<b>🎉 Special announcement from Bonfire 🎉</b>: The Pieland NFT public sale is starting soon! Learn more <a href="https://pieland.io">here</a>. 🥧', null)
    if (false) utils.showTopAlert('success', '<b>🎉 Special announcement from Bonfire 🎉</b>: The Pieland NFT public sale is live! <strike>Mint</strike> Bake your Octopies <a href="https://pieland.io/mint">now</a>. 🥧', null)
    if (false) utils.showTopAlert('success', '<b>🎉 Win a Zion 3-Badge S1 TS Debut!</b> LAST DAY for the Summer Madness Tournament! <a href="https://bit.ly/3OnOmLt">REGISTER NOW</a> and <a href="https://bit.ly/3RMkDyJ">CREATE A LINEUP</a>. 🏀', null)
    if (false) utils.showTopAlert('success', '<b>🎉 Win a rare Lebron S1 WCF Moment!</b> Create your SuperDraft rosters now! <a href="https://bit.ly/3JZIzeB">LEARN MORE</a>, <a href="https://bit.ly/3KgSixr">REGISTER</a> and <a href="https://bit.ly/3pmVDRT">CREATE A LINEUP</a>. 🏀', null)
    if (false) utils.showTopAlert('success', '<b>🎉 Win a Jayson Tatum TSD S1 Moment!</b> Create your SuperDraft rosters now! <a href="https://bit.ly/3KgSixr">REGISTER</a> and <a href="https://bit.ly/3AQzdxt">CREATE A LINEUP</a>. 🏀', null)
    if (false) utils.showTopAlert('success', '<b>🎉 Win a Kawhi TSD S1 Moment!</b> Create your SuperDraft rosters now! <a href="https://bit.ly/3KgSixr">REGISTER</a> and <a href="https://bit.ly/3DqOUhU">CREATE A LINEUP</a>. 🏀', null)
    if (false) utils.showTopAlert('success', '<b>🎉 Win a Zion S2 Moment!</b> Create your SuperDraft rosters now! <a href="https://bit.ly/3KgSixr">REGISTER</a> and <a href="https://bit.ly/3QWcohV">CREATE A LINEUP</a>. 🏀', null)
    if (false) utils.showTopAlert('success', '<b>🎉 Win a Lebron RIB or Magic Anthology Moment!</b> Create your SuperDraft rosters now! <a href="https://bit.ly/3KgSixr">REGISTER</a> and <a href="https://bit.ly/3RpjSKv">CREATE A LINEUP</a>. 🏀', null)
    if (false) utils.showTopAlert('success', '<b>🎉 The Grail - Win a Lebron Top Shot Debut!</b> Create your SuperDraft rosters now! <a href="https://bit.ly/3KgSixr">REGISTER</a> and <a href="https://bit.ly/3N8Uk3T">CREATE A LINEUP</a>. 🏀', null)
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

  // private functions not available directly to HTML template
  private doTabs(): void {
    this.links = []
    this.links.push({ name: 'MY ACCOUNT', path: '/myaccount' })
    this.links.push({ name: 'LISTINGS', path: '/listings' })
    this.links.push({ name: 'DEALS', path: '/deals' })
    this.links.push({ name: 'OFFERS', path: '/offers' })
    this.links.push({ name: 'LEADERBOARDS', path: '/leaderboards' })
    // this.links.push({ name: 'CHALLENGES', path: '/challenges' })
    this.links.push({ name: 'TOOLS', path: '/community-tools' })
    // this.links.push({ name: 'SALES', path: '/sales' })
    // console.log(this.links)
  }

}
